import window from 'window-or-global';

import { officeConnector } from './office-connector/overrides';

const overrideInitFunctions = [officeConnector];

const isDefined = (path) => {
	const pathParts = path.split('.');
	let obj = window[pathParts.shift()];
	while (typeof obj !== 'undefined' && pathParts.length) {
		obj = obj[pathParts.shift()];
	}
	return obj;
};

const lines = {};
const logOnce = (message) => {
	if (process.env.NODE_ENV !== 'production') {
		if (!lines[message]) {
			console.info(message);
			lines[message] = true;
		}
	}
};

// TODO: Relocate waitForGlobal so that it can be accessed by both confluence-editor
// and confluence-fabric-editor. Right now, waitForGlobal is in confluence-frontend-server,
// and thus I can't access from here. Since it is a small enough piece of functionality,
// and in the interest of time, I just made a copy of it here.

const waitForGlobal = ({ listener, globalProperty, interval = 25 }, callback) => {
	if (isDefined(globalProperty)) {
		logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
		callback();
		return null;
	}
	const waitForGlobalInterval = setInterval(() => {
		logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
		if (isDefined(globalProperty)) {
			logOnce(`window.${globalProperty} now available!`);
			clearInterval(waitForGlobalInterval);
			callback();
		}
	}, interval);
	return {
		cancel() {
			if (waitForGlobalInterval) {
				clearInterval(waitForGlobalInterval);
			}
		},
	};
};

/**
 * Run each plugin individually in try/catch block so the impact of a failure is isolated to the plugin only.
 * Note that this isolation is not perfect as plugin dependencies do exist.
 */
const initAllOverrides = () => {
	overrideInitFunctions.forEach((overrideInit, index) => {
		try {
			overrideInit();
		} catch (e) {
			// Do not rethrow this exception so the other plugin keep loading.
			// TODO: Add editorPluginAnalytics back in
			/*
      editorPluginAnalytics("initError", {
        fnName: pluginInit.name || index,
        message: e.message || "",
        exceptionName: e.name || ""
      });
      */
			if (process.env.NODE_ENV !== 'production') {
				console.error(
					`Editor macro browser override '${overrideInit.name || index}' failed to load`,
					e,
				);
			}
		}
	});
	return true;
};

let isLoaded = false;

export default () => {
	if (isLoaded) {
		return;
	}

	isLoaded = true;

	waitForGlobal(
		{
			listener: 'confluence-macro-browser-overrides/src/index',
			globalProperty: 'AJS.MacroBrowser',
		},
		() => {
			initAllOverrides();
		},
	);
};
